import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Button, Input, Select, Icon, Modal } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import Switchbox from '../../../../components/user/from/Switchbox'
import ViewDraftMeeting from '../../../../components/user/from/MeetingManagement/ViewDraftMeeting'
import ListWaitApproveMeeting from '../../../../components/user/from/MeetingManagement/ListWaitApproveMeeting'
import { UrlMeeting } from '../../../../utils/auth'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { TextArea } = Input;
const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography

class WaitApproveList extends React.Component {

    state = {
        dataMeeting: [],
        textApprove: "",
        typeApprove: "",
        showModalSuccess: false,
        showModalAccept: false,
        showModalAddNote: false,
        currentId: "",
        currentRemark: "",
        currentStatus: "",
        organizerName: "",

    }
    componentDidMount = () => {
        this.fetchDateMeeting();
    }
    fetchDateMeeting = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrequestapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingDate: "",
                MeetingName: "",
                OptionSearch: ""
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                console.log("data", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeSearchApprove = (value) => {
        // console.log("value", value);
        this.setState({
            textApprove: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrequestapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: value,
                OptionSearch: this.state.typeApprove,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                console.log("listmeetingrequestapproval", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    onChangeType = (value) => {
        console.log("value", value);
        this.setState({
            typeApprove: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetingrequestapproval`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: this.state.textApprove,
                OptionSearch: value,
            })
            .then(response => {
                const data = response.data.status.message.data
                this.setState({ dataMeeting: data ? data : [] })
                console.log("listmeetingrequestapproval", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    saveChangeAccept = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/approveMeeting`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingID: this.state.currentId,
                Status: this.state.currentStatus,
                Remark: this.state.currentRemark
            })
            .then(response => {
                this.fetchDateMeeting();
                this.handleCancel();
                this.setState({
                    showModalSuccess: true
                })
                setTimeout(() => {
                    this.setState({
                        showModalSuccess: false
                    })
                }, 2000);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    changeStatus = (id, status) => {
        const meeting = this.state.dataMeeting.find(o => o.id == id)
        const organizerName = meeting.firstNameOrganizer + " " + meeting.lastNameOrganizer
        if (status == "approve") {
            this.setState({
                showModalAccept: true,
                currentId: id,
                currentStatus: status,
                currentRemark: "",
                organizerName,
            });
        } else if (status == "reject") {
            this.setState({
                showModalAddNote: true,
                currentId: id,
                currentStatus: status,
                currentRemark: "",
                organizerName,
            });
        }
        // console.log(id, status, remark);
    }

    onChange = ({ target: { value } }) => {
        this.setState({ currentRemark: value });
        // console.log("this.state.remark",this.state.remark);
    };

    handleCancel = () => {
        this.setState({
            showModalAddNote: false,
            showModalSuccess: false,
            showModalAccept: false,
            currentId: "",
            currentRemark: "",
            organizerName: "",
        })
    }

    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Modal
                    className={'meeting-modal'}
                    visible={this.state.showModalAccept}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.saveChangeAccept}>
                            ยืนยัน</Button>,
                    ]}
                >
                    <div>
                        <div style={{ textAlign: "center" }}>
                            <p style={{ fontSize: "20px", marginBottom: "0px" }}>
                                {`อนุมัติการสร้างประชุมของคุณ`}
                            </p>
                            <p style={{ fontSize: "20px", marginBottom: "0px", color: "black" }}>
                                {`"${this.state.organizerName}"`}
                            </p>
                            <p style={{ fontSize: "20px", marginBottom: "0px" }}>
                                {`ใช่หรือไม่`}
                            </p>
                        </div>
                    </div>
                </Modal>

                <Modal
                    closable={false}
                    className={'list-invite-external-modal'}
                    visible={this.state.showModalAddNote}
                    // onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} disabled={this.state.currentRemark ? false : true} onClick={this.saveChangeAccept}>
                            ยืนยัน</Button>,
                    ]}
                >
                    <div>
                        <span style={{ fontSize: "20px" }}>
                            {"ไม่อนุมัติการสร้างประชุมของคุณ "}
                        </span>
                        <span style={{ fontSize: "20px", color: "black" }}>
                            "{this.state.organizerName}"
                        </span>
                        <span style={{ fontSize: "20px" }}>
                            {" ใช่หรือไม่"}
                        </span>
                        <TextArea
                            placeholder='กรอกเหตุผลที่ไม่อนุมัติการระชุม'
                            value={this.state.currentRemark}
                            onChange={this.onChange}
                            rows={8}
                        />
                    </div>
                </Modal>

                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalSuccess}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    {this.state.currentStatus == "approve" ?
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                            <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                            <p style={{ fontSize: "20px" }}>
                                อนุมัติการสร้างประชุมเรียบร้อย
                            </p>
                        </div>
                        :

                        <>
                            {this.state.currentStatus == "reject" ?
                                <div className={'py-5'} style={{ textAlign: 'center', color: "#D94339" }}>
                                    <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="close-circle" />
                                    <p style={{ fontSize: "20px" }}>
                                        ไม่อนุมัติการสร้างประชุม
                                    </p>
                                </div>
                                :

                                <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                                    <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                                    <p style={{ fontSize: "20px" }}>
                                        บันทึกการแก้ไขและอนุมัติการสร้างประชุมเรียบร้อย
                                    </p>
                                </div>
                            }
                        </>
                    }
                </Modal>

                <div className="card-container meeting-management" id="create-meeting">
                    <div className="card-bg-white">
                        <Row gutter={16} className={'py-4 p-5'}>
                            <Col xs={24} lg={12}>

                                <Search
                                    placeholder="ค้นหา"
                                    onSearch={value => this.onChangeSearchApprove(value)}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            <Col xs={24} md={12} lg={7} >
                                <Select
                                    showSearch
                                    defaultValue=""
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                    onChange={this.onChangeType}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option value="" >ทั้งหมด</Option>
                                    <Option value="WAITING">รออนุมัติ</Option>
                                    <Option value="APPROVE">อนุมัติ</Option>
                                    <Option value="REJECT">ไม่อนุมัติ</Option>
                                    <Option value="APPROVEAFTEREDIT">ขอแก้ไขและอนุมัติ</Option>
                                </Select>
                            </Col>
                            {/* <Col xs={24} md={12} lg={5} >
                                <Button className={'button-meeting-search mt-3 mt-lg-0'}>
                                    ค้นหา</Button>
                            </Col> */}
                            <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                                <ListWaitApproveMeeting dataMeeting={this.state.dataMeeting} changeStatus={this.changeStatus}></ListWaitApproveMeeting>
                            </div>
                        </Row>
                    </div>
                </div>
            </Container >
        )
    }
}

WaitApproveList.propTypes = {
    //
}

export default withApollo(WaitApproveList)